const bankInstitutionRoute = '/bank-institutions';

// Retrieve bank institutions
function retrieveBankInstitutions() {
    return window.tenantAxios.get(`${bankInstitutionRoute}`);
}

// Retrieve company bank account
function retrieveBankAccount(companyId) {
    return window.tenantAxios.get(`/company/${companyId}/bank-accounts`);
}

// Update company bank account
function update(companyId, bankAccountData) {
    return window.tenantAxios.patch(`/company/${companyId}/bank-accounts`, bankAccountData);
}

export default {
    retrieveBankInstitutions,
    retrieveBankAccount,
    update,
};
